<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: "ImportPr",
    components: {
        RawData,
    },
    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
        prItem: {
            type: Object,
            default: () => null,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            submitted: false,
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [10, 25, 50, 100],
            filter: "",
        };
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
        filteredData() {
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
    },
    methods: {
        removeFromConsolidation(item) {
            this.$emit("remove-from-consolidation", item);
        },
    }
};
</script>

<template>
    <b-modal
        id="consolidated-item-modal"
        title="Consolidated PR Item List"
        size="xl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row mt-1">
            <div class="col-sm-12">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
        </div>
        <div class="table-responsive mb-2">
            <table
                class="
                    table
                    align-middle
                    mb-0
                "
            >
                <thead class="table-light">
                    <tr>
                        <th>Product Desc</th>
                        <th width="200px">Note</th>
                        <th width="150px">Price</th>
                        <th width="150px">Quantity</th>
                        <th colspan="2">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <template
                        v-if="
                            filteredData.length >
                                0 && !loading
                        "
                    >
                        <tr
                            v-for="x in filteredData"
                            :key="x.id"
                            @drop="onDropZone($event, x)"
                            @dragenter.prevent
                            @dragover.prevent
                        >
                            <td class="position-relative">
                                <RawData :data="x" v-if="$store.state.decrypt.isAdmin()"/>
                                <h5 
                                    class="font-size-14 mb-0 text-white">
                                    {{ x.itemName}}
                                </h5>
                                <p class="mb-0">
                                    <span>{{ x.description}}</span>
                                </p>
                                <p class="mb-0 text-warning">
                                    <small>{{x.deliveryUnit}}</small>
                                </p>
                            </td>
                            <td>{{ x.note }}</td>
                            <td>{{ formatCurrency(x.unitCost) }}</td>
                            <td><span class="form-control cursor-pointer">{{ x.quantity }}</span></td>
                            <td style="width: 150px">{{ formatCurrency(x.total) }}</td>
                            <td style="width: 70px">
                                <a
                                    href="javascript:void(0);"
                                    class="
                                        action-icon
                                        text-danger
                                    "
                                    @click="removeFromConsolidation(x)"
                                    ><i
                                        class="
                                            mdi
                                            mdi-trash-can
                                            font-size-18
                                        "
                                    ></i
                                ></a>
                            </td>
                        </tr>
                    </template>
                    <tr
                        v-if="
                            filteredData.length ==
                                0 &&
                            filter &&
                            !loading
                        "
                    >
                        <td
                            colspan="5"
                            class="text-center"
                        >
                            Search not found
                        </td>
                    </tr>
                    <tr
                        v-if="
                            filteredData.length ==
                                0 &&
                            !filter &&
                            !loading
                        "
                    >
                        <td
                            colspan="5"
                            class="text-center"
                        >
                            No Items found
                        </td>
                    </tr>
                    <tr v-if="loading">
                        <td
                            colspan="5"
                            class="text-center"
                        >
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div
                                    class="
                                        preloader-component
                                        me-2
                                    "
                                >
                                    <div class="status">
                                        <div
                                            class="
                                                spinner-chase
                                                w-20px
                                                h-20px
                                            "
                                        >
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <strong
                                    >Loading...</strong
                                >
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>